module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loggedShop) ? _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_vm._v("\n    " + _vm._s((!_vm.order || !_vm.order.collected) ? _vm.$tr('Odbiór zamówienia', 'Order') : _vm.$tr('Zwrot zamówienia', 'Order')) + "\n    "), _c('router-link', {
    staticClass: "om-link-back",
    attrs: {
      "to": {
        name: (this.$route.name == 'Collect' ? 'CollectList' : 'OrderList')
      }
    }
  }, [_c('i', {
    staticClass: "om-ico-back-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$tr('wróć', 'Order')) + "\n    ")])], 1), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "om-order"
  }, [_c('ul', {
    staticClass: "om-order__general"
  }, [_c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Zamówienie:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.reference) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Imię i nazwisko:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.firstname + ' ' + _vm.order.lastname) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Telefon:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.phone) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Adres e-mail:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.email) + "\n      ")]), _vm._v(" "), (_vm.order.store_collect && _vm.order.store_collect.name) ? _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Miejsce odbioru:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-order__val"
  }, [_c('div', [_vm._v(_vm._s(_vm.order.store_collect.name))]), _vm._v(" "), (_vm.order.store_collect.address) ? _c('div', [_c('div', [_vm._v(_vm._s(_vm.$tr('ul.', 'Order')) + " " + _vm._s(_vm.order.store_collect.address.street) + " " + _vm._s(_vm.order.store_collect.address.flat ? ((_vm.order.store_collect.address.house) + "/" + (_vm.order.store_collect.address.flat)) : ("" + (_vm.order.store_collect.address.house))))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.store_collect.address.postcode) + " " + _vm._s(_vm.order.store_collect.address.city))])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.order.products) ? _c('div', {
    staticClass: "om-products"
  }, [_c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$tr('Produkty', 'Order')) + " (" + _vm._s(_vm.order.products.length) + ")")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$tr('Cena jednostkowa (brutto)', 'Order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$tr('Ilość', 'Order')))]), _vm._v(" "), (_vm.order.collected) ? _c('th', [_vm._v("\n              " + _vm._s(_vm.$tr('Ilość zwracanych produktów', 'Order')) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.order.products), function(p, k) {
    return _c('tr', {
      key: k
    }, [_c('td', [_c('div', {
      staticClass: "flex cen"
    }, [_c('div', {
      staticClass: "om-products__image"
    }, [_c('img', {
      attrs: {
        "src": p.image,
        "alt": p.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "om-products__desc fg-20"
    }, [_c('h4', {
      staticClass: "om-products__medium"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('h5', {
      staticClass: "om-products__small"
    }, [_vm._v(_vm._s(_vm.$tr('Kod produktu:', 'Order')) + " " + _vm._s(p.reference))]), _vm._v(" "), (p.attributes) ? _c('ul', {
      staticClass: "om-attributes"
    }, _vm._l((p.attributes), function(a, k) {
      return _c('li', {
        key: k,
        staticClass: "om-products__small"
      }, [_vm._v("\n                      " + _vm._s(k) + ": " + _vm._s(a) + "\n                    ")])
    }), 0) : _vm._e()])])]), _vm._v(" "), _c('td', {
      staticClass: "om-std"
    }, [_vm._v(_vm._s(p.price) + " "), _c('span', {
      staticClass: "currency"
    }, [_vm._v(_vm._s(p.currency))])]), _vm._v(" "), _c('td', {
      staticClass: "om-std"
    }, [_vm._v(_vm._s(p.quantity))]), _vm._v(" "), (_vm.order.collected && p.quantity - p.quantity_returned > 0) ? _c('td', {
      staticClass: "om-std"
    }, [_c('input', {
      staticClass: "om-input--qty",
      attrs: {
        "type": "text"
      },
      on: {
        "keyup": function($event) {
          $event.preventDefault();
          return _vm.orderReturnModify($event, p)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "om-slash"
    }, [_vm._v("/")]), _vm._v(" " + _vm._s(p.quantity - p.quantity_returned) + "\n            ")]) : (_vm.order.collected) ? _c('td', [_vm._v("\n              " + _vm._s(_vm.$tr('zwrócono wszystkie', 'Order')) + "\n            ")]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  }), _vm._v(" "), (_vm.anyDocumentsAvailable) ? _c('div', [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Dokumenty do pobrania:', 'Order')) + "\n      ")]), _vm._v(" "), (_vm.collectPDFCanBeDisplayed) ? _c('div', [_c('div', {
    staticClass: "om-pdf-link__line"
  }, [_c('button', {
    staticClass: "om-pdf-link",
    on: {
      "click": function($event) {
        return _vm.downloadCollectPDF($event, _vm.order.reference)
      }
    }
  }, [_c('i', {
    staticClass: "om-ico-file-pdf-o om-pdf-link__ico",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$tr("Potwierdzenie odbioru", 'Order')) + "\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.returnPDFCanBeDisplayed) ? _c('div', _vm._l((_vm.order.returns_pdf), function(code, k) {
    return _c('div', {
      key: k,
      staticClass: "om-pdf-link__line"
    }, [_c('button', {
      staticClass: "om-pdf-link",
      on: {
        "click": function($event) {
          return _vm.downloadReturnPDF($event, code)
        }
      }
    }, [_c('i', {
      staticClass: "om-ico-file-pdf-o om-pdf-link__ico",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n            " + _vm._s(_vm.$tr("Potwierdzenie zwrotu ", 'Order')) + " " + _vm._s(code) + "\n          ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  })]) : _vm._e(), _vm._v(" "), (!_vm.order.collected) ? _c('div', {
    staticClass: "om-order-state"
  }, [(typeof _vm.order.store_collect_details !== 'undefined' && _vm.order.store_collect_details.code !== _vm.loggedShop.code) ? _c('div', [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Zamówienie do odebrania w sklepie:', 'Order')) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.store_collect_details.name))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.$tr('ul.', 'ShopList')) + " " + _vm._s(_vm.order.store_collect_details.address.street) + "\n          " + _vm._s(_vm.order.store_collect_details.address.house) + "\n          " + _vm._s(typeof _vm.order.store_collect_details.address.flat !== 'undefined' && _vm.order.store_collect_details.address.flat !== '' ? ("/ " + (_vm.order.store_collect_details.address.flat)) : '') + "\n        ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.store_collect_details.address.postcode) + " " + _vm._s(_vm.order.store_collect_details.address.city))])]) : _c('div', [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Status odbioru', 'Order')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex cen"
  }, [_c('label', {
    staticClass: "om-dropdown__title"
  }, [_vm._v(_vm._s(_vm.$tr('Zamówienie:', 'Order')))]), _vm._v(" "), (_vm.states) ? _c('dropdown', {
    attrs: {
      "items": _vm.states,
      "default-label": _vm.defaultState ? _vm.defaultState.name : _vm.$tr('Wybierz', 'Order'),
      "default-value": _vm.defaultState ? _vm.defaultState.value : 0
    },
    on: {
      "change": _vm.changeChoosedState
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex h-cen"
  }, [_c('button', {
    staticClass: "om-btn om-btn--medium om-btn--update",
    attrs: {
      "id": "cta-push-order-state"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pushOrderState()
      }
    }
  }, [_vm._v(_vm._s(_vm.$tr('Aktualizuj status', 'Order')))])])])]) : _c('div', [(_vm.loggedShop.can_return) ? _c('div', {
    staticClass: "flex sb wrap"
  }, [_c('div', {
    staticClass: "om-col-8"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n            " + _vm._s(_vm.$tr('Podsumowanie zwrotu:', 'Order')) + "\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "om-summary"
  }, [_c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Nazwy produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._l((_vm.returnProducts), function(prod, i, k) {
    return _c('span', {
      key: i
    }, [_vm._v("\n                " + _vm._s(prod.name) + _vm._s(Object.keys(_vm.returnProducts).length > k + 1 ? ',' : '') + "\n              ")])
  }), _vm._v(" "), (!Object.keys(_vm.returnProducts).length) ? _c('span', [_vm._v("-")]) : _vm._e()], 2)]), _vm._v(" "), _c('li', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Ilość zwróconych produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.returnSummary.quantity))])]), _vm._v(" "), _c('li', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Wartość zwróconych produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$helper.displayPrice(_vm.returnSummary.value, _vm.returnSummary.currency)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "om-col-4"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Uwagi:', 'Order')) + " "), _c('span', {
    staticClass: "om-subheading__small"
  }, [_vm._v(_vm._s(_vm.$tr('(opcjonalnie)', 'Order')))])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "om-textarea",
    attrs: {
      "name": "message",
      "id": "message",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex h-cen fg-20"
  }, [_c('button', {
    staticClass: "om-btn om-btn--medium om-btn--update",
    attrs: {
      "id": "cta-push-return"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pushReturn()
      }
    }
  }, [_vm._v(_vm._s(_vm.$tr('Dokonaj zwrotu', 'Order')))])])]) : _c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Ten sklep nie może dokonywać zwrotów', 'Order')) + "\n      ")])]), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  })]) : (_vm.notFound) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.$tr('Brak szczegółów zamówienia', 'Order')) + "\n  ")]) : _c('div')]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a1c6287","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Order.vue
// module id = 278
// module chunks = 1